import AGREGAR_PRESUPUESTO_MODIFICADO from '@/graphql/mutations/administracion/presupuestos/agregarPresupuestoModificado.gql';
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';
import REMOVER_PRESUPUESTO_MODIFICADO from '@/graphql/mutations/administracion/presupuestos/removerPresupuestoModificado.gql';

export default {
  // apollo: {
  //   obras: {
  //     query: OBRAS,
  //   },
  // },
  data() {
    return {
      enviandoFormulario: false,
      nuevosDetalles: [],
    };
  },
  mounted() {},
  methods: {
    async mixAgregarPresupuestoModificado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      if (this.presupuestoModificado.tipo === 'REDUCCIÓN') {
        this.presupuestoModificado.importe *= -1;
      }

      await this.$apollo.mutate({
        mutation: AGREGAR_PRESUPUESTO_MODIFICADO,
        variables: {
          presupuestoModificado: this.presupuestoModificado,
        },
        update: (store, { data: { agregarPresupuestoModificado } }) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;

          const presupuesto = presupuestos.find(({ id }) => id === this.presupuestoId);
          if (!presupuesto) return;

          const { idPresupuestoDetalle } = this.presupuestoModificado;
          const detalle = presupuesto.detalles.find(({ id }) => id === idPresupuestoDetalle);

          if (!detalle) return;

          detalle.modificaciones.push(agregarPresupuestoModificado);
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('cerrar');
    },
    async mixEliminarPresupuestoModificado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PRESUPUESTO_MODIFICADO,
        variables: { id: this.modificacionId },
        update: (store) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;

          const presupuesto = presupuestos.find(({ id }) => id === this.presupuestoId);
          if (!presupuesto) return;

          const detalle = presupuesto.detalles.find(({ id }) => id === this.presupuestoDetalleId);
          if (!detalle) return;

          const index = detalle.modificaciones.findIndex(({ id }) => id === this.modificacionId);
          if (index === -1) return;

          detalle.modificaciones.splice(index, 1);
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.verEliminarModificacion = false;
      // this.cerrar();
    },
  },
};
